import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="header-top">
        <div className="container">
          <div className="header-top-content">
            <span className="age-badge">18+</span>
            <span className="header-notice">Play Responsibly | Licensed by UK Gambling Commission</span>
            <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer" className="header-help-link">
              Need Help?
            </a>
          </div>
        </div>
      </div>
      <div className="header-main">
        <div className="container">
          <div className="header-content">
            <Link to="/" className="logo">
              <div className="logo-icon">
                <span className="logo-text">SH</span>
              </div>
              <div className="logo-name">
                <span className="logo-brand">SlotsHub</span>
                <span className="logo-uk">UK</span>
              </div>
            </Link>
            
            <nav className={`nav ${mobileMenuOpen ? 'nav-open' : ''}`}>
              <NavLink to="/" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Home</NavLink>
              <NavLink to="/how-we-review" className="nav-link" onClick={() => setMobileMenuOpen(false)}>How We Review</NavLink>
              <NavLink to="/responsible-gambling" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Safe Gambling</NavLink>
              <NavLink to="/about" className="nav-link" onClick={() => setMobileMenuOpen(false)}>About</NavLink>
              <NavLink to="/contact" className="nav-link" onClick={() => setMobileMenuOpen(false)}>Contact</NavLink>
            </nav>

            <button 
              className="mobile-menu-btn"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label="Toggle menu"
            >
              <span className={`hamburger ${mobileMenuOpen ? 'open' : ''}`}></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
